define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var Border = (function () {
        function Border() {
            this.Left = 0;
            this.Right = 0;
            this.Top = 0;
            this.Bottom = 0;
        }
        return Border;
    }());
    exports.Border = Border;
});
//# sourceMappingURL=Border.js.map


//////////////////
// WEBPACK FOOTER
// ./wwwroot/js/Models/Configuration/Border.js
// module id = 379
// module chunks = 0